import { BaseSyntheticEvent, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { passwordValidateion } from "../../../common/Valitation";
import { OnsiteTextField } from "../../../customelements/CustomInput";
import { HttpPostData, JumpPage } from "../../../common/Util";
import { ResponseParamBase } from "../../../common/Types";
import { LoginStateConext } from "../../../context/AuthContext";
import { TitleParamContext } from "../../../context/TitleContext";
import { MessageParam } from "../../Message";
import market from "../../../css/market.module.scss";
import base from "../../../css/base.module.css";


//パスワード変更画面

export interface IFormInputs {
    currentPassword: string,
    password: string
    confirmationPassword: string
}

type ResponseParam = ResponseParamBase & {
}

const schema = Yup.object({
    currentPassword: passwordValidateion,
    password: passwordValidateion,
    confirmationPassword: passwordValidateion
}).required();

export const ChangePassword = () => {
    const { register, handleSubmit, control, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            currentPassword: "",
            password: "",
            confirmationPassword: ""
        },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const userProvider = useContext(LoginStateConext);
    const titleContext = useContext(TitleParamContext);
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");

    useEffect(() => {
        titleContext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "パスワード変更", secondSubTitle: "" });
    }, [])

    const onSubmit: SubmitHandler<IFormInputs> = (data: IFormInputs, event?: BaseSyntheticEvent) => {
        setMessage("");
        HttpPostData<ResponseParam>("/UserManager/ChangePassword", { username: userProvider.loginInfo.userName, email: userProvider.loginInfo.email, currentpassword: data.currentPassword, newpassword: data.password, newconfirmpassword: data.confirmationPassword }, setIsLoading)
            .then(response => {
                if (response.status == 200 && response.data.resultFlg) {
                    JumpPage<MessageParam>("Message", { message: "パスワードを変更しました。", displayButton: true }, "", navigate);
                } else {
                    setMessage(response.data.message);
                }
            })
            .catch(e => {
            })
    }

    return (
        <>
            <section className={market.marketArea}>
                <div className={market.marketAreaInner}>
                    <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                        <div className={market["layoutBox-l"]}>
                            <div className={market.marketInputTitle}>
                                <h3>現在のパスワード</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="currentPassword"
                                    control={control}
                                    render={({ field }) => (
                                        <OnsiteTextField
                                            sx={{ textAlign: "center" }}
                                            {...field}
                                            {...register("currentPassword")}
                                            error={errors.currentPassword ? true : false}
                                            helperText={errors.currentPassword?.message}
                                            margin="normal"
                                            type="password"
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className={market["layoutBox-l"]}>
                            <div className={market.marketInputTitle}>
                                <h3>新パスワード</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="password"
                                    control={control}
                                    render={({ field }) => (
                                        <OnsiteTextField
                                            {...field}
                                            {...register("password")}
                                            error={errors.password ? true : false}
                                            helperText={errors.password?.message}
                                            margin="normal"
                                            type="password"
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className={market["layoutBox-l"]}>
                            <div className={market.marketInputTitle}>
                                <h3>新パスワード（確認用）</h3>
                            </div>
                            <div className={market.marketInputTitleContents}>
                                <Controller
                                    name="confirmationPassword"
                                    control={control}
                                    render={({ field }) => (
                                        <OnsiteTextField
                                            {...field}
                                            {...register("confirmationPassword")}
                                            error={errors.confirmationPassword ? true : false}
                                            helperText={errors.confirmationPassword?.message}
                                            margin="normal"
                                            type="password"
                                        />
                                    )}
                                />                                
                            </div>                            
                        </div>
                        <div className={base.errorMessage}>{message}</div>
                        <div className={market.marketFooterArea}>
                            <button className={market.marketBackButton} type="button" onClick={(e) => { JumpPage("/MyPage", {}, "", navigate); }}>戻る</button>
                            <button className={market.marketButton} type="submit" disabled={!isValid || isLoading}>登録</button>
                            <button style={{ visibility: "hidden" }} className={market.marketBackButton}>＜　進む</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
}